import type {CanvasBrand} from '../bridge/protocol';

/**
 * An image available to the host. `sourceId` identifies the actual resource;
 * `url` is only the address used by the host to fetch it.
 */
export interface CanvasImageSource {
  sourceId: string;
  url: string;
}

export interface ComplianceInput {
  disclosure?: string | null;
  companyName?: string | null;
  companyLogo?: CanvasImageSource | null;
  dealerEnabled?: boolean | null;
  dealerName?: string | null;
  dealerLogo?: CanvasImageSource | null;
}

export interface AdvisorInput {
  id?: string | null;
  name?: string | null;
  email?: string | null;
  avatar?: CanvasImageSource | null;
}

/**
 * The complete host-side chrome rendered around a canvas. Image addresses stay
 * here; the iframe receives only semantic entity ids and opaque source ids.
 */
export interface CanvasChrome {
  brand: CanvasBrand | null;
  brandLogo: CanvasImageSource | null;
  compliance: ComplianceInput | null;
  advisor: AdvisorInput | null;
}

export const EMPTY_CANVAS_CHROME: CanvasChrome = {
  brand: null,
  brandLogo: null,
  compliance: null,
  advisor: null,
};
